import { render, staticRenderFns } from "./sucursales.vue?vue&type=template&id=08eab20d"
import script from "./sucursales.vue?vue&type=script&lang=js"
export * from "./sucursales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports